module.exports = __webpack_public_path__ + "img/weixin.20720d44.jpg";